import React from 'react';
import Card from '@mui/material/Card';
import { Skeleton } from '@mui/material';
import { Box, CardContent, Grid } from '@mui/material';

import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
  grid: {
    marginLeft: theme.spacing(2)
  },
  card: {
    backgroundColor: theme.palette.grey[200],
    borderColor: 'rgba(0,0,0,0.12)',
    borderRadius: theme.spacing(1),
    marginLeft: theme.spacing(0.5),
    marginTop: theme.spacing(2),
    width: theme.spacing(25)
  },
  media: {
    backgroundColor: theme.palette.background.paper,
    borderRadius: theme.spacing(0),
    height: theme.spacing(15),
    display: 'flex'
  },
  collectorIcon: {
    background: theme.skelton?.color,
    marginLeft: theme.spacing(7),
    height: theme.spacing(11),
    width: theme.spacing(11),
    alignSelf: 'center',
    display: 'flex'
  },
  icon: {
    background: theme.skelton?.color,
    marginLeft: 'auto',
    marginRight: theme.spacing(1.5),
    marginTop: theme.spacing(1),
    height: theme.spacing(3),
    width: theme.spacing(3),
    justifyContent: 'flex-end'
  },
  title: {
    background: theme.skelton?.color,
    marginBottom: theme.spacing(2),
    borderRadius: theme.spacing(0.5)
  },
  text: {
    background: theme.skelton?.color,
    marginTop: theme.spacing(0.2),
    borderRadius: theme.spacing(0.5)
  },
  cardAction: {
    height: theme.spacing(5),
    borderRadius: theme.spacing(0),
    backgroundColor: 'rgb(219, 219, 219)',
    padding: theme.spacing(1.25, 2, 0)
  },
  button: {
    background: theme.skelton?.color,
    borderRadius: theme.spacing(0.5),
    height: theme.spacing(2.5)
  }
}));

export const CollectorListPageSkeleton: React.FC = () => {
  const classes = useStyles();
  return (
    <Grid
      container
      spacing={1}
      className={classes.grid}
      data-testid="collector-list-page-skeleton"
    >
      {Array.from(new Array(5)).map((item, index) => (
        <Grid item key={index}>
          <Card
            className={classes.card}
            elevation={0}
            variant="outlined"
            data-testid="collector-note-skeleton"
          >
            <Box className={classes.media}>
              <Skeleton className={classes.collectorIcon} variant="circular" />
              <Skeleton className={classes.icon} variant="circular" />
            </Box>
            <CardContent>
              <Skeleton className={classes.title} variant="rectangular" />
              <Box>
                <Skeleton className={classes.text} variant="rectangular" />
                <Skeleton className={classes.text} variant="rectangular" />
                <Skeleton className={classes.text} variant="rectangular" />
              </Box>
            </CardContent>
            <Box className={classes.cardAction}>
              <Skeleton className={classes.button} variant="rectangular" />
            </Box>
          </Card>
        </Grid>
      ))}
    </Grid>
  );
};
